<template>
  <div class="menu-area">
    <IconLink
      type="home"
      :current="isHome"
      text="ホーム"
      @click-text="onClickHome"
    />
    <IconLink
      type="sight"
      :current="isSearch"
      text="観光"
      @click-text="onClickSearch"
    />
    <IconLink
      type="jyutai"
      :current="isJyutai"
      text="渋滞予測"
      @click-text="onClickJyutai"
    />
    <IconLink
      type="notifi"
      :current="isNotify"
      text="お知らせ"
      @click-text="onClickNotify"
    />
    <IconLink
      type="mypage"
      :current="isMyPage"
      text="マイページ"
      @click-text="onClickMyPage"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import IconLink from "@/components/Atoms/IconLink";

export default {
  name: "title-area",
  components: {
    IconLink,
  },
  props: {},
  computed: {
    ...mapState(["currentPageName"]),
    isHome() {
      return this.currentPageName === "Home";
    },
    isSearch() {
      return this.currentPageName === "RouteSearch";
    },
    isJyutai() {
      return this.currentPageName === "JyutaiSearch";
    },
    isNotify() {
      return this.currentPageName === "Notify";
    },
    isMyPage() {
      return this.currentPageName === "MyPage";
    },
  },
  methods: {
    ...mapMutations(["setCurrentPageName"]),
    onClickHome() {
      this.setCurrentPageName("Home");
    },
    onClickSearch() {
      this.setCurrentPageName("RouteSearch");
    },
    onClickJyutai() {
      this.setCurrentPageName("JyutaiSearch");
    },
    onClickNotify() {
      this.setCurrentPageName("Notify");
    },
    onClickMyPage() {
      this.setCurrentPageName("MyPage");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.menu-area {
  position: fixed;
  bottom: 0;
  width: calc(100% - 0.5rem * 2);
  border-bottom: #cdcdcd 1px solid;
  margin: 0em;
  text-align: center;
  padding: 0.25rem 0.5rem;
  font-size: 0.6rem;
  background: white;
  border-top: 1px solid #cdcdcd;
  display: flex;
  justify-content: space-between;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/MenuArea.vue